import React, { Component, cloneElement, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getPost } from '../../../stores/newsfeed/postPage/actions';

class InternalPost extends Component {
  componentWillMount() {
    const { getAPost, params } = this.props;
    getAPost(params.postId);
  }

  render() {
    const {
      children,
      params,
      ...props,
    } = this.props;

    return (
      <div>
        {children ? cloneElement(children, { ...props, postId: params.postId, displayType: 'internalPostPage' }) : undefined}
      </div>
    );
  }
}

InternalPost.propTypes = {
  children: PropTypes.object,
  params: PropTypes.object,
  getAPost: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  getAPost: (postId) => dispatch(getPost(postId)),
});

export default connect(null, mapDispatchToProps)(InternalPost);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/postPage/internal-container.jsx